module.exports = __webpack_public_path__ + "media/brands/hummer-d9cb12ca.png";